import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MycoplasmaGenitaliumUpsell, MycoplasmaHominisUreaplasmaUpsell } from '@data/tests';
import { environment } from '@environments/environment';
import { MycoplasmaResponse } from '@models/mycoplasma-response';
import { StorageService } from '@services/storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MycoplasmaService {
  public readonly mycoplasmaGenitaliumURL: string = 'mycoplasma-genitalium';
  public readonly mycoplasmaHominisUreaplasmaURL: string = 'mycoplasma-hominis-ureaplasma';

  private http = inject(HttpClient);
  private storage = inject(StorageService);

  /**
   * Checks if the Mycoplasma Genitalium Test is already ordered.
   */
  public isMycoplasmaGenitaliumTestOrdered(): boolean {
    return this.storage.orderedTests.some((test) =>
      [
        MycoplasmaGenitaliumUpsell.id,
        environment.order.stdPanelWithMycoplasmaTestId,
        ...environment.order.abTestsWithMycoplasmaTestId,
      ].includes(test.id),
    );
  }

  /**
   * Checks if the Mycoplasma Hominis With Ureaplasma Test is already ordered.
   */
  public isMycoplasmaHominisWithUreaplasmaTestOrdered(): boolean {
    return this.storage.orderedTests.some((test) => test.id === MycoplasmaHominisUreaplasmaUpsell.id);
  }

  /**
   * Get the Mycoplasma content based on the type.
   *
   * @param {'mycoplasma-genitalium' | 'mycoplasma-hominis-ureaplasma'} mycoplasmaType the type of mycoplasma content to fetch
   *
   * @returns an Observable of the MycoplasmaGenitaliumResponse
   */
  public getMycoplasmaContent(
    mycoplasmaType: 'mycoplasma-genitalium' | 'mycoplasma-hominis-ureaplasma',
  ): Observable<MycoplasmaResponse> {
    return this.http
      .get(`${environment.analyteCareApi}/api/v2/public-files/${mycoplasmaType}.json`, {
        responseType: 'text',
      })
      .pipe(map((responseText) => JSON.parse(responseText)));
  }
}
